import { useAppContext } from '../context/AppContext';
import BatchRange from './Modals/BatchRange';
import BatchStatic from './Modals/BatchStatic';
import ActivityChart from './ActivityChart';


const Overview = () => {
    const { user, company, activities } = useAppContext();

    const getInvoiceCount = (array) => {
        const filteredArray = array.filter(item => item.status_code === 200);    
        return filteredArray.length;
    }
    
    const getErrorCount = (array) => {
        const filteredArray = array.filter(item => item.status_code !== 200 && item.status_code !== 201);    
        return filteredArray.length;
    }
    
    const getTotalInvoiced = (array) => {
        const totalIncome = array.reduce((sum, current) => {
            if (current.status_code === 200) {
                return sum + (current.total_deal_revenue || 0);
            } else {
                return sum;
            }
        }, 0);
    
        const formattedTotalIncome = totalIncome.toLocaleString('en-US', {
          style: 'currency',
          currency: 'USD',
        });
    
        return formattedTotalIncome
    }


    return (
        <div>
            <div className="overview-header">
                <h1>Welcome{ user && user.fname ? `, ${user.fname}` : ''}</h1>
                { company && company.company_id === 6 && <BatchStatic /> }
                { company && company.company_id === 7 && <BatchRange /> }
                { company && company.company_id === 8 && <BatchStatic /> }
                {/* Test Companies */}
                { company && company.company_id === 134 && <BatchRange /> }
                { company && company.company_id === 100 && <BatchRange /> }
            </div>
            
            <div className="overview-content">
                <div className="overview-content-item" style={{background: 'rgba(75, 145, 226, .7)'}}>
                    <h4>{activities.length}</h4>
                    <p>Activities Processed</p>
                </div>
                <div className="overview-content-item" style={{background: 'rgba(0, 214, 164, .7)'}}>
                    <h4>{getInvoiceCount(activities)}</h4>
                    <p>Invoices Created</p>
                </div>
                <div className="overview-content-item" style={{background: 'rgba(255, 110, 97, .7)'}}>
                    <h4>{getErrorCount(activities)}</h4>
                    <p>Errors Occurred</p>  
                </div>
                <div className="overview-content-item" style={{background: 'rgba(10, 10, 10, 0.7)', color: 'white'}}>
                    <h4>{getTotalInvoiced(activities)}</h4>
                    <p>Revenue Generated</p>
                </div>
            </div>

            <div className="chart-content">
                <ActivityChart days={7} />
                <ActivityChart days={30} />
            </div>
        </div>
    );
};

export default Overview;